module.exports = __webpack_public_path__ + "img/Toshiba-identifire-image.10dc980d.png";